import { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HEADER, GLOBAL_IMAGES } from "../../assets/asset";
import HandleAIQuestions from "./HandleAIQuestions";
import { colors } from "../../assets/components/ai/constants";
import ExitScreenModal from "./ExitScreenModal.jsx";
import { useDispatch, useSelector } from "react-redux";
import Lottie from "lottie-react";
import loadingAnimation from "../../assets/global/loading.json";
import { Loader2 } from "lucide-react";
import {
  forceMute,
  rememberCurrentValue,
  restoreOlderValue,
} from "../../store/slice/muteSlice.js";

const AIHandler = () => {
  const dispatch = useDispatch();
  const [questions, setQuestions] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [setAttemptedCount] = useState(0);
  const [showConfirmExitScreen, setShowConfirmExitScreen] = useState(false);

  const { yearId } = useParams();
  const { token } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const fetchAIQuestions = useCallback(async () => {
    if (!token || !yearId) return;
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/aiNextquestions`,
        {
          method: "POST",
          headers: {
            Authorization: `${process.env.REACT_APP_AUTH_TOKEN_DEV}`,
            "Content-Type": "application/json",
            jwt: token,
          },
          body: JSON.stringify({ YearId: yearId }),
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();
      console.log("result:", result);
      setQuestions(result.data);
      setLoading(false);
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  }, [token, yearId]);

  const handleCorrectAnswer = useCallback(() => {
    setAttemptedCount((prev) => prev + 1);
  }, []);

  const handleQuestionsComplete = async (payload) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/aiNextquestionAnswearSubmmit`,
        {
          method: "POST",
          headers: {
            Authorization: `${process.env.REACT_APP_AUTH_TOKEN_DEV}`,
            "Content-Type": "application/json",
            jwt: token,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      fetchAIQuestions();
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    fetchAIQuestions();
  }, [fetchAIQuestions]);

  useEffect(() => {
    dispatch(rememberCurrentValue());
    dispatch(forceMute());

    return () => {
      dispatch(restoreOlderValue());
    };
  }, []);

  if (loading)
    return (
      <div className="flex items-center justify-center h-screen w-screen bg-white">
        {/* <Lottie className="w-48 h-48" animationData={loadingAnimation} /> */}
        <Loader2 className="h-12 w-12 animate-spin text-gray-600" />
      </div>
    );
  if (error) return <div>Error: {error}</div>;

  return (
    <div
      className=" min-h-screen flex flex-col items-center overflow-y-auto  "
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.aiBG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
      }}
    >
      {showConfirmExitScreen && (
        <ExitScreenModal
          onClose={() => setShowConfirmExitScreen(false)}
          navigate={navigate}
        />
      )}
      <div
        className=" h-[100px] justify-between  flex items-center  w-full "
        style={{ background: "#36363699" }}
      >
        <img src={HEADER.AI} alt="AI" className="w-20  h-15" />
        <div className=" ">
          <button
            onClick={() => setShowConfirmExitScreen(true)}
            className=" text-white px-12 mr-4 font-mali text-xl font-bold py-2 rounded-lg hover:bg-red-700"
            style={{ background: colors.linearGradient }}
          >
            Exit
          </button>
        </div>
      </div>
      <div className="flex  flex-1  my-[5rem]">
        {questions && (
          <HandleAIQuestions
            questions={questions}
            yearId={yearId}
            onQuestionsComplete={handleQuestionsComplete}
            onCorrectAnswer={handleCorrectAnswer}
            colorTheme="#ffffff"
          />
        )}
      </div>
    </div>
  );
};

export default AIHandler;
